// extracted by mini-css-extract-plugin
export default {"container":"UDmuS6PVCYWwVKO42gVx","orderNumber":"SqoDtQ8uVpKJR3e01Nxg"};